export enum LoggingLevel {
    DEBUG,
    INFO,
    WARN,
    ERROR,
    NONE
}

